export const LOTTERY_TYPES = {
  lt6: {
    key: "lt6",
    tableName: "lottery_numlot_lt6",
    label: "ロト6",
    shortLabel: "ロト6",
    path: "/loto6/",
    mainNumbers: 6,
    bonusNumbers: 1,
    hasCarryover: true,
    type: "loto",
    colors: {
      primary: "#e3007f", // ピンク
      secondary: "#1e3c94", // 青
      accent: "#f7b400", // 黄色
    },
    catchcopy: "1〜43から6つを選ぶ数字選択式宝くじ",
    drawDay: "月・木",
    price: 200,
    maxPrize: 200000000,
    maxPrizeCo: 600000000,
    maxPrizeLabel: "理論値",
    statsPath: "/loto6/stats",
  },
  lt7: {
    key: "lt7",
    tableName: "lottery_numlot_lt7",
    label: "ロト7",
    shortLabel: "ロト7",
    path: "/loto7/",
    mainNumbers: 7,
    bonusNumbers: 2,
    hasCarryover: true,
    type: "loto",
    colors: {
      primary: "#e60012", // 赤
      secondary: "#1d2088", // 青
      accent: "#f29600", // 黄色
    },
    catchcopy: "1〜37から7つを選ぶ大型キャリーオーバーくじ",
    drawDay: "金",
    price: 300,
    maxPrize: 700000000,
    maxPrizeCo: 1200000000,
    maxPrizeLabel: "理論値",
    statsPath: "/loto7/stats",
  },
  mlt: {
    key: "mlt",
    tableName: "lottery_numlot_mlt",
    label: "ミニロト",
    shortLabel: "ミニロト",
    path: "/miniloto/",
    mainNumbers: 5,
    bonusNumbers: 1,
    hasCarryover: false,
    type: "loto",
    colors: {
      primary: "#e50012", // 赤
      secondary: "#2c4197", // 青
      accent: "#f29600", // 黄色
    },
    catchcopy: "1〜31から5つを選ぶコンパクトなロトくじ",
    drawDay: "火",
    price: 200,
    maxPrize: 10000000,
    maxPrizeCo: null,
    maxPrizeLabel: "理論値",
    statsPath: "/miniloto/stats",
  },
  nm4: {
    key: "nm4",
    tableName: "lottery_numlot_nm4",
    label: "ナンバーズ4",
    shortLabel: "ナンバーズ4",
    path: "/numbers4/",
    mainNumbers: 1, // winning_number 1つとして扱う
    bonusNumbers: 0,
    hasCarryover: false,
    type: "numbers",
    colors: {
      primary: "#004098", // 青
      secondary: "#00a73c", // 緑
      accent: "#f39800", // 黄色
    },
    catchcopy: "0〜9の4桁数字を当てるくじ",
    drawDay: "月〜金",
    price: 200,
    maxPrize: 900000,
    maxPrizeCo: null,
    maxPrizeLabel: "理論値",
    statsPath: "/numbers4/stats",
  },
  nm3: {
    key: "nm3",
    tableName: "lottery_numlot_nm3",
    label: "ナンバーズ3",
    shortLabel: "ナンバーズ3",
    path: "/numbers3/",
    mainNumbers: 1,
    bonusNumbers: 0,
    hasCarryover: false,
    type: "numbers",
    colors: {
      primary: "#e62e8b", // ピンク
      secondary: "#004098", // 青
      accent: "#f39800", // 黄色
    },
    catchcopy: "0〜9の3桁数字を当てるくじ",
    drawDay: "月〜金",
    price: 200,
    maxPrize: 90000,
    maxPrizeCo: null,
    maxPrizeLabel: "理論値",
    statsPath: "/numbers3/stats",
  },
  bg5: {
    key: "bg5",
    tableName: "lottery_numlot_bg5",
    label: "ビンゴ5",
    shortLabel: "ビンゴ5",
    path: "/bingo5/",
    mainNumbers: 8,
    bonusNumbers: 0,
    hasCarryover: false,
    type: "bingo",
    colors: {
      primary: "#e3007f", // ピンク
      secondary: "#211513", // 黒茶
      accent: "#f7b400", // 黄色
    },
    catchcopy: "1〜33の8つの数字でビンゴを狙うくじ",
    drawDay: "水",
    price: 300,
    maxPrize: 5556200,
    maxPrizeCo: null,
    maxPrizeLabel: "理論値",
    statsPath: "/bingo5/stats",
  },
  qcc: {
    key: "qcc",
    tableName: "lottery_numlot_qcc",
    label: "着せかえクーちゃん",
    shortLabel: "クーちゃん",
    path: "/qoochan/",
    mainNumbers: 4,
    bonusNumbers: 0,
    hasCarryover: false,
    type: "kisekae",
    colors: {
      primary: "#dc2e81", // ピンク
      secondary: "#202870", // 紺
      accent: "#fbbb04", // 黄色
    },
    catchcopy: "4つの数字を当てる着せかえくじ（販売終了）",
    drawDay: "月・木",
    price: 200,
    maxPrize: 10500,
    maxPrizeCo: null,
    maxPrizeLabel: "理論値",
    statsPath: "/qoochan/stats",
  },
};
export default LOTTERY_TYPES;
